import { useParams } from "react-router-dom";
import styled from "styled-components";
import NavBar from "../../../Componentes/NavBar";
import { useModal } from "../../../contexts/ModalContext";

import SidebarAditivos from "./SidebarAditivos";
import ModalNovoAditivo from "./ModalNovoAditivo";
import { useEffect, useState } from "react";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import { formatarData } from "../../../Funcoes/FormatarData";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import ModalViewItem from "./ModalViewItem";

import { FiEdit2 } from "react-icons/fi";
import ModalEditItem from "./ModalEditItem";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    background-color: #242d34;
    display: flex;
    flex-direction: column;
`
const BodyWrapper = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
    box-sizing: border-box;
    gap: 15px;
    overflow: hidden;
`
const InfoWrapper = styled.div`
    width: 100%;
    height: 100px;
    background-color: #FFF;
    border-radius: 12px;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
`
const CardWrapper = styled.div`
    height: 100%;
    display: flex;
    gap: 10px;
    margin-left: auto;
`
const InfoCard = styled.div`
    height: 100%;
    background-color: #f0f0f0;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding: 0 20px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    gap: 2px;
    h3 {
        margin: 0;
        font-size: 11px;
        font-weight: normal;
    }
    p {
        margin: 0;
        font-size: 20px;
        font-weight: bold;
    }
    &:hover {
        transform: scale(1.02);
    }
`
const TabelaWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #FFF;
    border-radius: 12px;
    overflow: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 2;
    }
    tbody {
        tr {
            border-bottom: 1px solid #ccc;
            // Adicionar linha sim e, linha não para melhor visualização
            &:nth-child(even) {
                background-color: #fafafa;
            }
            // Adicionar hover em azul claro
            &:hover {
                background-color: #e0f7fa;
                cursor: pointer;
            }
        }
        td {
            padding-left: 15px;
        }
    }
`
const LinhaCabecalho = styled.tr`
    height: 45px;
`
const ColunaCabecalho = styled.th`
    text-align: left;
    padding: 0 15px;
    color: #242d34;
    font-size: 15px;
`
const LoadingContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const LoadingWrapper = styled.div`
    width: 350px;
    height: 120px;
    background-color: #f0f0f0;
    border-radius: 10px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const WrapperColuna = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    & p {
        margin: 0;
    }
    margin: 15px 0;
`
const ColunaAcoes = styled.td`
    width: 220px;
    padding: 0 50px 0 0;
    box-sizing: border-box;
`
const AcoesWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
`
const IconeWrapper = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`
const EditIcone = styled(FiEdit2)`
    color: #333;
    font-size: 30px;
    cursor: pointer;
    transition: .3s;
    &:hover {
        color: #007bff;
        transform: scale(1.1);
    }
`


const InfoPedidoCompra = () => {

    // Pegar o id do pedido de compra da url

    const { id } = useParams();
    const { openModal, isModalOpen, closeModal } = useModal();

    const api = useApi();

    const [loading, setLoading] = useState(true);

    const handleOpenModal = () => {

        openModal("modalAditivoSidebar");

    }

    const [data, setData] = useState([]);

    const fetchData = async () => {

        try {

            setLoading(true);

            const { data } = await api.get("/Painel/API/ControleMedicao/PedidoInfo/index.php?id=" + id);

            console.log(data.pedido_compra);
            setData(data);


        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const [selectedItem, setSelectedItem] = useState(null);

    const openViewModal = (isPedido, id) => {

        setSelectedItem({ isPedido, id });
        openModal("modalViewAditivo");

    }

    const closeViewModal = () => {

        setSelectedItem(null);
        closeModal();

    }

    const handleOpenEditModal = (isPedido, id, e) => {

        e.stopPropagation();

        setSelectedItem({ isPedido, id });
        openModal("modalEditarItem");

    }

    return (
        <Container>
            <NavBar goBackOnePage title="CONTROLE DE MEDIÇÕES" setSideBar={handleOpenModal} />
            <BodyWrapper>
                <InfoWrapper>
                    <CardWrapper>
                        <InfoCard>
                            <p>{formatBRLFromCents(data?.soma_faturamento || 0)}</p>
                            <h3>FATURAMENTO</h3>
                        </InfoCard>
                        <InfoCard>
                            <p>{formatBRLFromCents(data?.soma_faturamento_direto || 0)}</p>
                            <h3>FATURAMENTO DIRETO</h3>
                        </InfoCard>
                        <InfoCard>
                            <p>{formatBRLFromCents(data?.soma_total || 0)}</p>
                            <h3>TOTAL</h3>
                        </InfoCard>
                    </CardWrapper>
                </InfoWrapper>
                <TabelaWrapper>
                    {
                        loading ? (
                            <LoadingContainer>
                                <LoadingWrapper>
                                    <SmallLoading />
                                </LoadingWrapper>
                            </LoadingContainer>
                        ) : (
                            <Tabela>
                                <thead>
                                    <LinhaCabecalho>
                                        <ColunaCabecalho colSpan={3} > PEDIDO DE COMPRA: {data?.descricao} - {data?.num_pedido} </ColunaCabecalho>
                                    </LinhaCabecalho>
                                </thead>
                                <tbody>
                                    <tr onDoubleClick={() => openViewModal(true, data?.pedido_compra.id)} >
                                        {
                                            // Deixar a primeira linha com os dados do pedido de compra, e as linhas seguintes com os aditivos, caso existam.
                                            // Para que isso fique de forma mais visual, criar um componente que mostre que a primeira linha é o pedido de compra, deixando ela em destaque.
                                        }
                                        <td>
                                            <WrapperColuna>
                                                <p><b>DESCRIÇÃO:</b> {data?.pedido_compra.descricao}</p>
                                                <p><b>TIPO CONTRATO:</b> {data?.pedido_compra.tipo_contrato}</p>
                                            </WrapperColuna>
                                        </td>
                                        <td>
                                            <WrapperColuna>
                                                <p><b>DATA:</b> {formatarData(data.pedido_compra.data_contrato)}</p>
                                                <p><b>FATURAMENTO:</b> {formatBRLFromCents(data.pedido_compra.valor_faturamento)}</p>
                                            </WrapperColuna>
                                        </td>
                                        <ColunaAcoes>
                                            <AcoesWrapper>
                                                <IconeWrapper>
                                                    <EditIcone onClick={(e) => handleOpenEditModal(true, data?.pedido_compra.id, e)} />
                                                </IconeWrapper>
                                            </AcoesWrapper>
                                        </ColunaAcoes>
                                    </tr>
                                    {
                                        data.aditivos.map((aditivo) => (
                                            <tr
                                                key={aditivo.id}
                                                onDoubleClick={() => openViewModal(false, aditivo.id)}
                                            >
                                                <td>
                                                    <WrapperColuna>
                                                        <p><b>DESCRIÇÃO:</b> {aditivo.descricao}</p>
                                                        <p><b>TIPO CONTRATO:</b> {aditivo.tipo_aditivo}</p>
                                                    </WrapperColuna>
                                                </td>
                                                <td>
                                                    <WrapperColuna>
                                                        <p><b>DATA:</b> {formatarData(aditivo.data)}</p>
                                                        <p><b>FATURAMENTO:</b> {formatBRLFromCents(aditivo.faturamento)}</p>
                                                    </WrapperColuna>
                                                </td>
                                                <ColunaAcoes />
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </Tabela>
                        )
                    }
                </TabelaWrapper>
            </BodyWrapper>
            {
                isModalOpen("modalAditivoSidebar") && (
                    <SidebarAditivos />
                )
            }
            {
                isModalOpen("modalNovoAditivo") && (
                    <ModalNovoAditivo
                        fetchData={fetchData}
                    />
                )
            }
            {
                isModalOpen("modalViewAditivo") && (
                    <ModalViewItem
                        isPedido={selectedItem?.isPedido}
                        id={selectedItem?.id}
                        fecharModal={closeViewModal}
                    />
                )
            }
            {
                isModalOpen("modalEditarItem") && (
                    <ModalEditItem
                        isPedido={selectedItem?.isPedido}
                        id={selectedItem?.id}
                        fetchData={fetchData}
                        fecharModal={closeViewModal}
                    />
                )
            }
        </Container>
    )
}

export default InfoPedidoCompra;